<framework-launch-button
  (topButtonLaunch)="createCampaign(campaignName.value)"
  (bottomButtonLaunch)="createCampaign(campaignName.value)"
  [topButtonDisabled]="disabled"
  [bottomButtonDisabled]="disabled || !newCampaignForm.valid"
  [disabled]="disabled"
  [loading]="disabled"
  [collapsedWidth]="180"
  [expandedWidth]="230"
  [expandedHeight]="140"
  [(expanded)]="expanded"
>
  <div topButton>Launch Campaign <mat-icon>launch</mat-icon></div>
  <form #newCampaignForm="ngForm" style="margin: 0px">
    <mat-form-field appearance="outline">
      <mat-label>Campaign Name</mat-label>
      <input
        matInput
        placeholder="Campaign Name"
        #campaignName
        [(ngModel)]="localCampaignName"
        name="campaignName"
        [required]="true"
      />
    </mat-form-field>
  </form>

  <div bottomButton>Create Campaign <mat-icon>campaign</mat-icon></div>
</framework-launch-button>
